document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tabs").forEach((wrap) => {
    const tabList = wrap.querySelector(".section-tabs[role='tablist']");
    const tabs = tabList ? Array.from(tabList.querySelectorAll("[role='tab']")) : [];
    const panelsWrap = wrap.querySelector(".section-tabs-data");
    if (!tabs.length || !panelsWrap) return;

    let activeIndex = tabs.findIndex(t => t.getAttribute("aria-selected") === "true");
    if (activeIndex < 0) activeIndex = 0;

    function getPanelForTab(tab) {
      const panelId = tab.getAttribute("aria-controls");
      if (!panelId) return null;
      return panelsWrap.querySelector("#" + CSS.escape(panelId));
    }

    function updateViewAll(panel) {
      if (!panel) return;
      const section = wrap.closest('.carousel-products');
      if (!section) return;
      const btn = section.querySelector('.sec-head .btn');
      const text = btn?.querySelector('.text');
      if (!btn) return;
      const url = panel.getAttribute('data-collection-url');
      const title = panel.getAttribute('data-title');
      if (url) btn.setAttribute('href', url);
      if (text) text.textContent = title ? title : 'View All';
    }

    function setActiveTab(index, moveFocus = true) {
      const activeTab = tabs[index];
      activeIndex = index;

      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");

        const panel = getPanelForTab(tab);
        if (panel) {
          panel.hidden = !isActive;
          panel.setAttribute("aria-hidden", isActive ? "false" : "true");
        }
      });

      // Fallback for single tab
      if (tabs.length === 1) {
        const singlePanel = getPanelForTab(tabs[0]) || panelsWrap.querySelector(".tab-data");
        if (singlePanel) {
          singlePanel.hidden = false;
          singlePanel.setAttribute("aria-hidden", "false");
        }
        updateViewAll(singlePanel);
      } else {
        updateViewAll(getPanelForTab(activeTab));
      }

      // Dispatch custom event for jQuery slick and view-all sync
      activeTab.dispatchEvent(new CustomEvent("tab:activated", {
        bubbles: true,
        detail: { index, tab: activeTab }
      }));

      if (moveFocus && activeTab) activeTab.focus();
    }

    // Click handler
    tabs.forEach((tab, i) => {
      tab.addEventListener("click", () => setActiveTab(i, false));
    });

    // Keyboard navigation
    if (tabList) {
      tabList.addEventListener("keydown", (e) => {
        const key = e.key;
        let next = activeIndex;

        if (key === "ArrowRight") next = (activeIndex + 1) % tabs.length;
        else if (key === "ArrowLeft") next = (activeIndex - 1 + tabs.length) % tabs.length;
        else if (key === "Home") next = 0;
        else if (key === "End") next = tabs.length - 1;
        else if (key === "Enter" || key === " ") {
          e.preventDefault();
          setActiveTab(activeIndex, false);
          return;
        } else return;

        e.preventDefault();
        setActiveTab(next, true);
      });
    }

    // Init
    setActiveTab(activeIndex, false);
  });
});